export default "__VITE_ASSET__DihpSWRA__"